<template>
    <div class="">
        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div class="bg-liff">
            <div class="header-text">
                <div>
                    {{$vuetify.lang.t('$vuetify.liffOvertimeRequest.approvalInquiry')}}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <div
                v-if="isDataTablePage"
                class="data-container">
                <div class="ml-day-inquiry">
                    <span class="label-tag">
                        {{$vuetify.lang.t('$vuetify.liffOvertimeRequest.date')}}
                    </span>
                    <v-menu
                        v-model="datePickerShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="234px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                prepend-inner-icon="event"
                                @click:prepend-inner="datePickerShow = true"
                                v-model="dateFormatted"
                                readonly
                                v-on="on"
                                solo
                                height="40px"
                                background-color="#ffffff"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            v-model="search.inquireDate"
                            @change="saveInquireDate"
                            @input="datePickerShow = false"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <div>
                    <v-card>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [10, 20, 30, 50, 100]
                            }"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                            :headers="headers"
                            :options.sync="options"
                            :server-items-length="totalData"
                            :items="overTimeRequire"
                            @click:row="seeDetail"
                            :loading="loading">
                        </v-data-table>
                    </v-card>
                    <div
                        class="pt-2 paginator-box">
                        <div>
                            <v-pagination v-model="page" :length="pageCount"></v-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="form-container">
                <overtime-review-detail
                    :requestNo="requestNo"
                    :lineId="search.lineId"
                    @back-button="displayTableList"
                    @updated-status="getOverTimeInquiryPagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import OvertimeReviewDetail from '@/components/liff/OvertimeReviewDetail'
import axios from 'axios'
export default {
    name: 'OvertimeReview',
    components: {
        ChangeLang,
        LiffErrorModal,
        OvertimeReviewDetail
    },

    data () {
        return {
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            search: {
                lineId: '',
                inquireDate: this.$util.getCurrentDate()
            },

            overTimeRequire: [],
            pageCount: 1,
            page: 1,
            totalData: 0,
            options: {},
            loading: false,
            errorMsg: '',
            isDataTablePage: true,
            requestNo: null
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.employeeNo'), value: 'employee_no', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.employeeName'), value: 'fullname', width: '40%' },
                { text: this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.date'), value: 'start_date', width: '20%', sortable: false }
            ]
        }
    },

    methods: {
        closeWindow () {
            this.$liff.closeWindow()
        },

        errorAlert (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        async getOverTimeInquiryPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `${process.env.VUE_APP_BACKEND}/overtime-review-line?lineId=${this.search.lineId}`
            if (page) {
                url += `&page=${page}`
            }
            if (itemsPerPage) {
                url += `&itemsPerPage=${itemsPerPage}`
            }
            if (sortBy && sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }
            if (sortDesc && sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }
            if (this.search.inquireDate) {
                url += `&inquireDate=${this.search.inquireDate}`
            }

            const res = await axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.overTimeRequire = res.data.data
                this.totalData = res.data.total
            }
            this.loading = false
            this.isDataTablePage = true
        },

        displayTableList () {
            this.isDataTablePage = true
        },

        async saveInquireDate () {
            this.dateFormatted = this.$util.formatDate(this.search.inquireDate)
            await this.getOverTimeInquiryPagination()
        },

        async seeDetail (data) {
            this.isDataTablePage = false
            this.requestNo = data.request_no
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.search.lineId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_OT_APPROVAL_LIFF)
            await this.getOverTimeInquiryPagination()
        } catch (error) {
            this.errorAlert(this.$vuetify.lang.t('$vuetify.liffOvertimeRequest.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        options: {
            async handler () {
                if (this.search.lineId) {
                    await this.getOverTimeInquiryPagination()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.bg-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        color: #6c6c6c;
        padding: 2rem;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }

    .form-container {
        overflow: scroll;
        height: 90%;
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
    }
}

@media screen and (orientation: landscape) {
    .bg-liff {
        display: flex;
        flex-direction: column;
        align-items: center;

        .data-container {
            min-width: 350px;
        }
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

::v-deep .v-data-footer__icons-before {
    display: none;
}
::v-deep .v-data-footer__icons-after {
    display: none;
}
</style>
